<div>
  <form #f="ngForm" (ngSubmit)="onSendMail(f.value)">
    <mat-card appearance="outlined">
      <mat-card-header fxLayout="row" fxLayoutAlign="center">
        <mat-card-title role="heading" aria-level="1">System Notification</mat-card-title>
      </mat-card-header>
      <mat-card-content fxLayout="row" fxLayoutAlign="center">
        <div fxFlex="100" fxLayout="row" fxLayoutGap="8px">
          <div fxLayout="column" fxFlex="100">
            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label>Subject</mat-label>
              <input matInput name="subject" ngModel type="text" required>
            </mat-form-field>
            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label>Message</mat-label>
              <textarea matInput name="emailBody" ngModel type="text" class="message_layout" required></textarea>
            </mat-form-field>
          </div>
        </div>
      </mat-card-content>
      <mat-card-actions fxLayout="row" fxLayoutAlign="center">
        <button mat-raised-button type="submit" color="primary" [disabled]="!f.valid || !f.dirty || saving" class="spinner-black">
          <div *appSpinner="saving"></div>
          Send Notification
        </button>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
